import { render, staticRenderFns } from "./juegos.vue?vue&type=template&id=0ef4cf6e"
import script from "./juegos.vue?vue&type=script&lang=js"
export * from "./juegos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports